import React from 'react';
import { FLAME_MIRROR, FLAME_PATH } from 'src/design/atoms/flamePath';

export interface IFireIconProps extends React.SVGProps<SVGSVGElement> {
  /** Rendered edge length in px; drives both width and height. */
  size?: number;
}

/** @registry Solid F.I.R.E. flame glyph on a 24x24 box; drop-in replacement for a Tabler icon, fills with currentColor. Scales from 14px chrome to the chat empty-state hero. */
export const FireIcon = React.forwardRef<SVGSVGElement, IFireIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="none"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d={FLAME_PATH} transform={FLAME_MIRROR} />
    </svg>
  ),
);
